import { createActions, createReducer } from "reduxsauce"
import { takeEvery, put, delay } from "redux-saga/effects"
import { v4 as uuid } from "uuid"
import API_MESSAGES from "api/messages"

export const { Types, Creators } = createActions({
  add: (level, title, message) => ({ type: "ompnt/modules/notifications/ADD", level, title, message, id: uuid() }),
  addApiNotification: (level, title, code, message) => ({ type: "ompnt/modules/notifications/ADD_API_NOTIFICATION", level, title, code, id: uuid(), message }),
  dismiss: ["id"],
}, {
  prefix: "ompnt/modules/notifications/",
})

const INITIAL_STATE = {
  notifications: [],
}

function handleAdd(state, { id, level, title, message }) {
  return { ...state, notifications: [...state.notifications, { id, level, title, message }] }
}

function handleAddApiNotification(state, { id, level, title, code, message }) {
  return { ...state, notifications: [...state.notifications, { id, level, title, message: API_MESSAGES[code] || message || "An unexpected error occurred. Please try again." }] }
}

function handleDismiss(state, { id }) {
  return { ...state, notifications: state.notifications.filter(notification => notification.id !== id) }
}

export const HANDLERS = {
  [Types.ADD]: handleAdd,
  [Types.ADD_API_NOTIFICATION]: handleAddApiNotification,
  [Types.DISMISS]: handleDismiss,
}

export default createReducer(INITIAL_STATE, HANDLERS)

function* dismissNotifications(action) {
  const { id, level, alert } = action

  if ((level === "success" || (alert && alert.status === "success")) || (level === "info" || (alert && alert.status === "info"))) {
    // Needs to be the same as the delay in toaster.styl
    yield delay(8000)
    yield put(Creators.dismiss(id))
  }
}

export function* saga() {
  yield takeEvery([Types.ADD, Types.ADD_API_NOTIFICATION], dismissNotifications)
}
